export default __webpack_public_path__ + "static/media/robo_hand.ba8ec4da.webp";